import React from "react";
import { Outlet } from "react-router-dom";
import { Result } from "antd";

class ErrorBoundary extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            error: false,
            message: "",
        };
    }

    static getDerivedStateFromError(error) {
        // Actualiza el estado para que el siguiente renderizado muestre la interfaz de repuesto
        return { error: true, message: error.message };
    }

    render() {
        if (this.state.error) {
            return (
                <Result
                    status='500'
                    title='Error'
                    subTitle='Se produjo un error, página no encontrada.'
                    // extra={<Button type="primary" >Volver a Mis Seguros</Button>}
                />
            );
        }
        return <Outlet />;
    }
}

export default ErrorBoundary;
